/**
 * Phase 7.1 — Media-query hook.
 * Returns true when viewport is below the app's mobile breakpoint (1024px,
 * matching Tailwind's `lg:`). Subscribes to `matchMedia` change events so
 * the value updates live as the window resizes.
 */
import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 1024) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // Modern browsers use addEventListener; older Safari uses addListener.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
